import { CalendarIcon } from '@mui/x-date-pickers';
import React from 'react';
import { DefaultCustomField, FileLinkWithMimeType } from '../../constants/types';
import { formatCustomFieldToHtml as formatCustomFieldHelper } from 'src/helpers/formatCustomField';
import { formatUnicodeStylesToHtml } from 'src/components/TemplateText/helpers';
import ChatFileIcon from '../ChatFileIcon/view';
import { ChatBubble, ChatContainer, PhoneWrapper, Screen } from './styles';

export interface IMessage {
  isUser: boolean;
  text: string | null;
  links?: string[];
  linksWithMimeType?: FileLinkWithMimeType[];
  subject?: string;
  position?: number;
  attachCalendar?: boolean;
  dataCapture?: boolean;
}

const Phone = ({
  messages,
  metadata,
  optOutText,
}: {
  messages: IMessage[];
  metadata: DefaultCustomField[] | undefined;
  optOutText: string;
}) => {
  const formatMessage = (message: string) => {
    // Don't process short links as custom fields
    const formattedMessage = message.replaceAll(/{{[^{}]+(?=})}}/g, (match: string) => {
      // Check if this looks like a short link - if so, don't process it
      const fieldName = match.replace(/^{{|}}$/g, '');
      if (fieldName.includes('mention-link') || fieldName.includes('short') || fieldName.includes('link')) {
        return match; // Return unchanged - this is a short link
      }
      return formatCustomFieldHelper(match, metadata || [], { includeClass: false });
    });
    return formattedMessage;
  };



  const stripHtml = (html: string | null) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    return tmp.textContent || tmp.innerText || '';
  };

  return (
    <PhoneWrapper>
      <Screen>
        <ChatContainer>
          {messages.map((content, index) =>
            content.subject ||
            content.text ||
            (content.linksWithMimeType && content.linksWithMimeType.length > 0) ? (
              <React.Fragment key={index}>
                {(stripHtml(content.text) || content.subject || !!content.linksWithMimeType?.length) && (
                  <ChatBubble $isUser={content.isUser}>
                    {content.linksWithMimeType?.map((item: FileLinkWithMimeType, index) => {
                      return <ChatFileIcon url={item.url} mimeType={item.mimeType} key={index} />;
                    })}

                    <>
                      {content.subject && (
                        <div
                          style={{ marginBottom: '6px' }}
                          dangerouslySetInnerHTML={{ __html: content.subject }}
                        />
                      )}
                      {content.text && (
                        <div
                          dangerouslySetInnerHTML={{ __html: formatUnicodeStylesToHtml(formatMessage(content.text)) }}
                        />
                      )}

                      {!content.isUser && optOutText && content.position === 1 && (
                        <div style={{ marginTop: '15px' }}>{optOutText}</div>
                      )}
                    </>
                  </ChatBubble>
                )}
                {content.attachCalendar && stripHtml(content.text) && (
                  <ChatBubble $isUser={false}>
                    <CalendarIcon />
                  </ChatBubble>
                )}
                {content.dataCapture && stripHtml(content.text) && (
                  <ChatBubble $isUser={true}>Yes</ChatBubble>
                )}
              </React.Fragment>
            ) : null,
          )}
        </ChatContainer>
      </Screen>
    </PhoneWrapper>
  );
};

export default Phone;
